import React from 'react'
import { Switch, Route } from 'react-router-dom'
import loadable from '@loadable/component'

import VoucherCreate from '../pages/vouchers/Create'
import VoucherPay from '../pages/vouchers/Pay/index'
import VoucherCreateSuccess from '../pages/vouchers/Success'

import UserProfile from '../pages/user/UserProfile'
import Bucketlist from '../pages/bucketlist'
import Loading from '../components/display/Loading'
import Referral from '../pages/referral'

const UserRoutes = loadable(
  () => import('./UserRoutes' /* webpackChunkName: "user" */),
  {
    fallback: <Loading />,
  }
)
const BookingRoutes = loadable(
  () => import('./BookingRoutes' /* webpackChunkName: "bookings" */),
  {
    fallback: <Loading />,
  }
)

export default (
  <React.Fragment>
    <Route exact path="/vouchers/create" component={VoucherCreate} />
    <Route path="/vouchers/:voucherId/pay" component={VoucherPay} />
    <Route
      path="/vouchers/:voucherId/success"
      component={VoucherCreateSuccess}
    />
    <Route path="/users/:userId" component={UserProfile} />

    <Route path="/bucket-lists/:token" component={Bucketlist} />
    <Route exact path="/referrals/:token" component={Referral} />

    <Switch>
      <Route path="/my/bookings" component={BookingRoutes} />
      <Route path="/my/" component={UserRoutes} />
    </Switch>
  </React.Fragment>
)
